import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import { password } from 'constants/zoom';
import { ROUTE_INITIATIVES } from 'constants/urls';
import { TYPE_SPEED_DATING } from 'constants/meetings';
import ConfirmModal from 'components/ConfirmModal';
import SpeedDatingBar from './SpeedDatingBar';
import { Header, ZoomIframe } from './styles';

class ZoomMeeting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: true,
      showModalFinish: false,
      doFinishMeeting: false,
      barHeight: 0,
    };
  }

  componentDidMount() {
    const { zoomData } = this.props;
    if (isMobile) {
      this.openInZoomApp();
    }

    let barHeight = 50;
    if (zoomData && zoomData.meeting && zoomData.meeting.type && zoomData.meeting.type === TYPE_SPEED_DATING) {
      barHeight = 128;
    }

    this.setState({ barHeight });
  }

  showModalFinish = () => {
    this.setState({ showModalFinish: true });
  }

  closeModalFinish = () => {
    this.setState({ showModalFinish: false });
  }

  acceptModalFinish = () => {
    this.setState({ doFinishMeeting: true, showModalFinish: false });
  }

  openInZoomApp = () => {
    const { meetingId: meetingNumber, history } = this.props;
    history.push('/main');
    window.openMeetingZoom(meetingNumber, password);
  }

  closeModalWindow = () => {
    this.setState({ showModal: false, barHeight: 0 });
  }

  openMeeting = () => {
    const { history } = this.props;
    history.push(ROUTE_INITIATIVES);
  }

  backToHome = () => {
    const { history } = this.props;
    history.push(ROUTE_INITIATIVES);
  }

  printOpenInZoomAppBar = () => {
    const { meetingURL, literals } = this.props;
    const { showModal } = this.state;
    if (!showModal) {
      return null;
    }

    return (
      <div id='headerBar'>
        <div className='header_bar modal_new_window'>
          {literals.problemOpenNewWindow}
          <a href={meetingURL} onClick={this.openMeeting} target='_blank' rel='noopener noreferrer'>{literals.openANewWindow}</a>
          {literals.or}
          <a href='#' onClick={this.backToHome} rel='noopener noreferrer'>{literals.backToHome}</a>
          <button className='close_button' style={{ display: 'none' }} type='button' onClick={this.closeModalWindow}>
            <i className='far fa-times-circle' />
          </button>
        </div>
      </div>
    );
  }

  printSpeedDatingHeader = () => {
    const {
      zoomData: {
        meeting: {
          name, image, end_date: endDate, user: { id }, id: meetingId, element_id: elementId,
        },
      },
      literals,
      app,
    } = this.props;
    const { doFinishMeeting } = this.state;

    return (
      <div className='header_bar'>
        <SpeedDatingBar
          app={app}
          userId={id}
          avatar={image}
          name={name}
          meetingId={meetingId}
          elementId={elementId}
          literals={literals}
          endDate={endDate}
          showModalFinish={this.showModalFinish}
          closeModalFinish={this.closeModalFinish}
          doFinishMeeting={doFinishMeeting}
        />
      </div>
    );
  }

  printExtraInfo = () => {
    const { zoomData } = this.props;
    if (!zoomData || !zoomData.meeting || !zoomData.meeting.type) {
      return null;
    }

    const { meeting: { type } } = zoomData;

    switch (type) {
      case 21275704:
        return this.printSpeedDatingHeader();
      default:
        return null;
    }
  }

  render() {
    const { literals, user, meetingId } = this.props;
    const { showModalFinish, barHeight } = this.state;
    const urlMeeting = `https://meetings.webintra.net/zoom/${meetingId}?username=${encodeURIComponent(`${user.name} ${user.surname}`)}`;

    return (
      <React.Fragment>
        {showModalFinish && (
          <ConfirmModal
            open={showModalFinish}
            confirmText={literals.confirmText}
            onClose={this.closeModalFinish}
            onAccept={this.acceptModalFinish}
          />
        )}

        <Header>
          {this.printOpenInZoomAppBar()}
          {this.printExtraInfo()}
        </Header>
        <ZoomIframe src={urlMeeting} allow='camera;microphone' height={barHeight} />
      </React.Fragment>
    );
  }
}

ZoomMeeting.propTypes = {
  app: PropTypes.object.isRequired,
  meetingId: PropTypes.string.isRequired,
  meetingURL: PropTypes.string.isRequired,
  zoomData: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
};

export default ZoomMeeting;



// WEBPACK FOOTER //
// ./src/components/ZoomMeeting/components/index.jsx